import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from '../services/authService';
import { act } from 'react';

const user = JSON.parse(localStorage.getItem('user'));
const theme = localStorage.getItem('theme');

const initialState = {
  user: user ? user : null,
  error: false,
  success: false,
  loading: false,
  users: [],
  isAuthenticated: user ? true : false,
  theme: theme ? true : false,
  isSuper: false,
};

// Sing in a user
export const login = createAsyncThunk('auth/login', async (user, thunkAPI) => {
  const response = await authService.login(user);
  if (response) {
    const data = {
      acess: response.access,
    };
    localStorage.setItem('user', JSON.stringify(data));
    return data;
  }
  return response;
});

export const logout = createAsyncThunk('auth/logout', async () => {
  authService.logout();
});

// export const choiceTheme = createAsyncThunk('auth/theme', async (theme, thunkAPI) => {
//   const response = authService.choiceTheme(theme);
//   return response;
// });

export const getUsers = createAsyncThunk('auth/getUsers', async (_, thunkAPI) => {
  const response = await authService.getUsers();
  return response;
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
    },
    choiceTheme: (state) => {
      const theme = localStorage.getItem('theme');
      state.theme = theme ? true : false;
    },
    isSuper: (state, action) => {
      state.isSuper = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.user = action.payload;
        state.isAuthenticated = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.user = null;
        state.isAuthenticated = false;
      })
      .addCase(logout.fulfilled, (state, action) => {
        state.loading = false;
        state.error = true;
        state.user = null;
        state.isAuthenticated = false;
      })
      .addCase(getUsers.pending, (state, action) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.users = action.payload;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.user = null;
      });
  },
});

export const { reset, choiceTheme, isSuper } = authSlice.actions;
export default authSlice.reducer;
